/** Node2D registration: parser and formatter. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNode2D } from './parser';
import { formatNode2DProperties } from './propertyFormatter';
const node2DRegistration = {
    typeName: 'Node2D',
    parser: parseNode2D,
    propertyFormatter: formatNode2DProperties,
};
nodeRegistry.register(node2DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map